import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Brain, SignOut, Target, Gear, Sparkle, ShieldCheck, List, X } from '@phosphor-icons/react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-white/10 bg-background/80 backdrop-blur-xl backdrop-saturate-150 p-4">
      <div className="container flex items-center justify-between relative">
        <Link to="/" className="flex items-center gap-2" onClick={closeMenu}>
          <Brain size={32} weight="duotone" className="text-primary" />
          <span className="font-heading text-2xl font-black uppercase tracking-widest">MockRank</span>
        </Link>
        {user !== null && user !== false ? (
          <div className="flex items-center gap-4 md:gap-6">
            <div className="hidden md:flex items-center gap-4 text-sm font-bold uppercase tracking-widest text-muted-foreground">
              <Link to="/dashboard" className="hover:text-primary transition-colors duration-150">Dashboard</Link>
              <Link to="/tests" className="hover:text-primary transition-colors duration-150">Mock Tests</Link>
              <Link to="/leaderboard" className="hover:text-primary transition-colors duration-150">Leaderboard</Link>
              <Link to="/coach" className="hover:text-primary transition-colors duration-150">AI Coach</Link>
              <Link to="/guides" className="hover:text-primary transition-colors duration-150 flex items-center gap-1"><Sparkle size={14}/> Guides</Link>
            </div>
            
            <div className="flex items-center gap-2 md:gap-3">
              {user.role === 'admin' && (
                <Link to="/admin" className="hidden sm:block">
                  <Button variant="ghost" className="border border-chart-4/50 bg-chart-4/10 text-chart-4 hover:bg-chart-4/20 hover:text-chart-4 rounded-none px-3 font-black tracking-widest text-xs uppercase flex items-center gap-1">
                    <ShieldCheck size={16} /> ADMIN
                  </Button>
                </Link>
              )}
              <div className="hidden lg:flex items-center gap-1 border border-border px-3 py-1 bg-secondary rounded-sm">
                <Target size={16} className="text-accent" />
                <span className="text-xs font-bold uppercase tracking-wider">{user.target_exam || 'EXAM'}</span>
              </div>
              <Link to="/settings" onClick={closeMenu}>
                <Button variant="ghost" className="border-border rounded-none text-muted-foreground hover:text-white px-2">
                  <Gear size={20} />
                </Button>
              </Link>
              <Button variant="outline" className="border-border rounded-none hidden sm:flex" onClick={handleLogout} data-testid="logout-btn">
                <SignOut size={18} />
              </Button>
              
              {/* Mobile Menu Toggle */}
              <Button variant="ghost" className="md:hidden border-border rounded-none text-muted-foreground hover:text-white px-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-toggle">
                {mobileMenuOpen ? <X size={24} /> : <List size={24} />}
              </Button>
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-4">
            <Link to="/login"><Button variant="ghost" className="rounded-none border-border">LOGIN</Button></Link>
            <Link to="/register"><Button className="rounded-none bg-primary text-white hover:bg-primary/90">REGISTER</Button></Link>
          </div>
        )}
      </div>

      {/* Mobile Navigation Dropdown */}
      {mobileMenuOpen && user && (
        <div className="md:hidden absolute top-full left-0 w-full bg-background border-b border-border shadow-2xl animate-in slide-in-from-top-2 z-50">
          <div className="flex flex-col p-4 space-y-4 text-sm font-bold uppercase tracking-widest text-muted-foreground">
            <Link to="/dashboard" className="hover:text-primary p-2 border-b border-white/5" onClick={closeMenu} data-testid="mobile-nav-dashboard">Dashboard</Link>
            <Link to="/tests" className="hover:text-primary p-2 border-b border-white/5" onClick={closeMenu} data-testid="mobile-nav-tests">Mock Tests</Link>
            <Link to="/leaderboard" className="hover:text-primary p-2 border-b border-white/5" onClick={closeMenu} data-testid="mobile-nav-leaderboard">Leaderboard</Link>
            <Link to="/coach" className="hover:text-primary p-2 border-b border-white/5" onClick={closeMenu} data-testid="mobile-nav-coach">AI Coach</Link>
            <Link to="/guides" className="hover:text-primary p-2 border-b border-white/5 flex items-center gap-2" onClick={closeMenu} data-testid="mobile-nav-guides"><Sparkle size={14}/> Guides</Link>
            
            {user.role === 'admin' && (
              <Link to="/admin" className="text-chart-4 p-2 border-b border-white/5 flex items-center gap-2" onClick={closeMenu} data-testid="mobile-nav-admin">
                <ShieldCheck size={16} /> ADMIN CONSOLE
              </Link>
            )}
            
            <button onClick={handleLogout} className="text-destructive p-2 flex items-center gap-2 text-left" data-testid="mobile-nav-logout">
              <SignOut size={16} /> LOGOUT
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};